import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './components/home/home.component';
import { SigninComponent } from './components/signin/signin.component';
import { SignonComponent } from './components/signon/signon.component';
import { NewsComponent } from './components/news/news.component';
import { ForumComponent } from './components/forum/forum.component';
import { BlogComponent } from './components/blog/blog.component';
import { ShopComponent } from './components/shop/shop.component';
import { AboutComponent } from './components/about/about.component';
import { ContactComponent } from './components/contact/contact.component';
import { JobComponent } from './components/job/job.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'signin', component: SigninComponent },
  { path: 'signon', component: SignonComponent },
  { path: 'news', component: NewsComponent },
  { path: 'forum', component: ForumComponent },
  { path: 'blog', component: BlogComponent },
  { path: 'shop', component: ShopComponent },
  { path: 'about', component: AboutComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'job', component: JobComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class DarkadiaRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/darkadia-routing.module.ts